export const Unicorn = () => (
  <svg fill="none" height="40" width="40" xmlns="http://www.w3.org/2000/svg">
    <g stroke="white" strokeLinejoin="round" strokeWidth="2">
      <path d="m8 32h-5s-.5-14 5.2-20 8.3-6.5 13.8-7l2 5" />
      <path
        d="m25 9.5 8.521-7.1a.2.2 0 0 1 .322.203l-2.843 10.897m0 0 6 9.5c-1 2.5-4 5-6 5-3.572 0-5.672-3-9-3-2 0-3.5-2-4-4"
        strokeLinecap="round"
      />
      <path d="m12.5 15.5c-4.5 5.5-4.5 19.5-4.5 19.5h18s-1.5-3.5-2-9" strokeLinecap="round" />
    </g>
    <path
      clipRule="evenodd"
      d="m25 9.5c-1.5 1-3 .5-3 .5s-3.5-3-6-6c-2 1-5 6 0 9"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="m25 9.5c-1.5 1-3 .5-3 .5s-3.5-3-6-6c-2 1-5 6 0 9m11 6.082c0-1-.923-1.666-1.5-2-.577-.333-1.5-.5-2.5 0"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
)

export const Document = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99988 5H23.9999L31.9999 13V34C31.9999 34.5523 31.5522 35 30.9999 35H8.99988C8.44759 35 7.99988 34.5523 7.99988 34V6C7.99988 5.44772 8.44759 5 8.99988 5Z"
      fill="white"
    />
    <path d="M26.9999 17H12.9999V19H26.9999V17Z" fill="#CFD6E6" />
    <path d="M26.9999 21.0001H12.9999V23.0001H26.9999V21.0001Z" fill="#CFD6E6" />
    <path d="M20.9999 25H12.9999V27H20.9999V25Z" fill="#CFD6E6" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 5L32 13H25C24.4477 13 24 12.5523 24 12V5Z"
      fill="#CFD6E6"
    />
  </svg>
)

export const Upload = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_499_37979)">
      <path
        d="M18.4085 1C18.6395 1.04165 18.8705 1.0686 19.0966 1.12494C19.6054 1.24951 20.0631 1.53075 20.4059 1.92957C20.7488 2.32839 20.9597 2.82495 21.0095 3.35018C21.0592 3.87542 20.9453 4.40322 20.6835 4.86018C20.4217 5.31713 20.0251 5.68053 19.5488 5.89982C18.8607 6.2183 18.1605 6.3898 17.4116 6.11786C16.8452 5.94161 16.3603 5.56661 16.0449 5.06092C15.7295 4.55522 15.6045 3.95235 15.6925 3.36171C15.7697 2.77247 16.0381 2.22548 16.4559 1.80587C16.8737 1.38626 17.4174 1.11758 18.0024 1.04165C18.0696 1.03154 18.1362 1.01764 18.2018 1H18.4085Z"
        fill="#currentColor"
      />
      <path
        d="M18.8956 36.482C8.79286 36.482 5.05815 38.197 5.03626 31.7243C5.0241 28.8065 4.40652 18.5315 8.79287 22.0276C10.3295 23.2525 9.00198 30.3303 9.89189 32.5622C14.4801 32.9076 27.8434 32.6283 29.4384 31.8272C29.752 28.8236 28.5047 23.0075 30.7538 21.2926C34.7681 18.2155 33.9147 28.9657 33.9512 32.0011C34.0484 38.4419 30.9751 36.482 18.8956 36.482Z"
        fill="#currentColor"
      />
      <path
        d="M17.4926 13.3062C17.1765 13.6418 15.3407 16.104 14.8617 16.4911C14.6933 16.6372 14.4964 16.7463 14.2837 16.8112C14.071 16.8762 13.8472 16.8957 13.6266 16.8684C12.7293 16.741 12.2236 15.8884 12.4935 14.9893C12.7658 13.5193 14.9249 11.8044 15.917 10.3345C16.0872 10.0895 17.2786 8.16629 17.4926 7.95315C18.295 7.14958 18.7083 7.12998 19.6614 7.7547C20.1283 8.06584 21.3975 10.1654 21.8279 10.5329C23.2527 11.7579 23.9457 12.1474 24.9888 13.7178C25.3826 14.3156 25.5115 15.4327 24.9499 15.8835C24.7285 16.1007 24.4444 16.2414 24.1385 16.2855C23.8326 16.3295 23.5207 16.2745 23.2478 16.1285C22.6108 15.859 22.2242 15.3151 21.6333 14.7198C20.8455 13.926 20.2839 13.3331 20.0578 13.1298C20.0724 13.3968 20.5635 18.086 20.6486 20.0777C20.7337 22.1185 20.9379 23.5983 21.0425 25.6366C21.1325 27.4324 20.1769 28.2433 19.4669 28.2163C19.1491 28.2044 18.8371 28.1273 18.5499 27.9897C18.2628 27.8521 18.0064 27.657 17.7966 27.4162C17.5868 27.1755 17.4279 26.8941 17.3296 26.5894C17.2314 26.2847 17.1958 25.963 17.2251 25.6439C17.2981 24.049 17.495 23.2553 17.495 19.0855C17.5047 17.8434 17.4901 13.3944 17.4926 13.3062Z"
        fill="#currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_499_37979">
        <rect width="29" height="38.2553" fill="white" transform="translate(5 1)" />
      </clipPath>
    </defs>
  </svg>
)

export const CreateDocument = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_499_37992)">
      <path
        d="M18.7587 35.9536C16.5404 35.9536 14.3244 35.9774 12.1085 35.9416C10.9174 35.9225 9.32595 35.9416 8.12997 35.7459C5.5186 35.3402 5.06046 34.0752 5.06046 31.6883C5.06046 30.2563 4.9423 28.8767 5.03634 27.4637C5.14003 25.9337 5.32009 25.3763 5.45753 23.8511C5.5374 23.2034 5.69943 22.5683 5.93978 21.9608C6.1809 21.4094 6.51607 20.9869 7.09236 20.8748C7.66865 20.7626 8.27387 21.0585 8.58492 21.734C8.83019 22.2835 9.03488 22.8499 9.19737 23.4287C9.7182 25.1949 9.58877 30.4711 9.67076 31.4497C9.69487 31.7289 15.8083 31.6892 19.8085 31.7179C20.896 31.7179 29.3634 31.2826 29.4116 30.7336C29.4912 29.829 29.6696 28.0866 29.6937 27.182C29.7395 25.485 29.8842 23.8711 30.1277 22.809C30.4822 21.2576 31.2875 20.5988 32.5245 21.3769C33.1104 21.7517 33.4022 22.3579 33.5734 23.0477C33.8724 24.2411 34.0219 25.8287 33.9978 27.6308C33.9857 28.6308 34.0122 31.6883 33.5734 33.3591C33.0116 35.7244 26.9618 35.703 25.6163 35.7459C22.9639 35.8509 21.4014 35.913 18.7443 35.9846L18.7587 35.9536Z"
        fill="currentColor"
      />
      <path
        d="M21.2394 15.4418C21.1245 16.3764 21.1245 17.3209 21.2394 18.2555C21.3956 19.3811 21.3797 20.5228 21.1922 21.644C20.8768 23.2843 18.4281 23.5789 17.7601 22.0367C17.1541 20.5712 17.3478 19.8049 17.3478 18.2555C17.3478 17.6928 17.3104 15.5411 16.8286 15.4286C16.0091 15.3304 15.0854 15.4585 14.0474 15.4418C12.4232 15.4178 10.6848 15.5112 10.3992 14.2037C9.96461 12.2089 12.0705 12.3622 14.2435 12.2544C15.1762 12.186 16.33 12.305 17.2102 12C17.4337 11.9282 17.472 9.22758 17.3652 7.75246C17.1715 4.93871 17.9488 4 19.116 4C20.477 4 21.1847 5.15663 21.0605 7.93924C21.0439 9.1928 20.9132 10.6329 21.0605 11.8785C21.9634 12.0203 23.0739 11.896 23.9885 11.8785C26.2832 11.8282 28.635 11.639 28.6573 13.3799C28.6797 14.9892 27.0471 14.9854 24.8418 15.0476C23.7069 15.0859 21.9496 15.2885 21.2394 15.4418Z"
        fill="#currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_499_37992">
        <rect width="29" height="32" fill="white" transform="translate(5 4)" />
      </clipPath>
    </defs>
  </svg>
)
